<template>
  <router-view />
</template>

<script>
export default {
  name: 'admins-pages-container',
};
</script>
